const SELECTOR_COUNTER = ".countdown-counter";
const SELECTOR_HIDDEN_COMPONENT = ".hidden-component";
const SELECTOR_COUNTER_COMPONENT = ".banner-countdown";
const SELECTOR_LABEL_DAYS = ".labelDays";
const CLASS_HIDDEN = "hidden";

class BannerFullsizeCountdown extends HTMLElement {

  constructor() {
    super();
    this.targetDate = null;
    this.previewDate = null;
  }

  connectedCallback() {
    this.setElements();
    this.setParams();
    this.setTimer();
  }

  setElements() {
    this.counter = this.querySelector(SELECTOR_COUNTER);
    this.counterComponent = this.querySelector(SELECTOR_COUNTER_COMPONENT);
    this.hiddenComponent = this.querySelector(SELECTOR_HIDDEN_COMPONENT);
    this.labelDays = this.querySelector(SELECTOR_LABEL_DAYS);

    if (!this.counterComponent && this.hiddenComponent) {
      this.hiddenComponent.classList.remove(CLASS_HIDDEN);
    }
  }

  setParams() {
    this.targetDate = this.counter.dataset['counterDate'];
    this.previewDate = this.counter.dataset['previewDate'];
  }
  
  setTimer() {
    // Set the date we're counting down to
    const countdownDate = new Date(this.targetDate).getTime();

    // Update the count down every 1 second
    const interval = setInterval(() => {
      // Get today's date and time
      const now = this.previewDate ? new Date(this.previewDate).getTime() : new Date().getTime();
      // Find the distance between now and the countdown date
      const distance = countdownDate - now;

      // Time calculations for days, hours, minutes and seconds
      const days = Math.max(Math.floor(distance / (1000 * 60 * 60 * 24)), 0);
      const hours = Math.max(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), 0);
      const minutes = Math.max(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)), 0);
      const seconds = Math.max(Math.floor((distance % (1000 * 60)) / 1000), 0);

      // Display the result in the element with id="…"
      if (days < 1) {
        this.querySelector(".counterDays").nextElementSibling.classList.add(CLASS_HIDDEN);
      } else {
        this.setCountdownValue(".counterDays", days);
      }
      this.setCountdownValue(".counterHours", hours);
      this.setCountdownValue(".counterMinutes", minutes);
      if (days < 1) {
        this.querySelector(".counterSeconds").nextElementSibling.classList.remove(CLASS_HIDDEN);
        this.setCountdownValue(".counterSeconds", seconds);
      } else {
        this.querySelector(".counterSeconds").nextElementSibling.classList.add(CLASS_HIDDEN);
      }

      // Label "Tage" anpassen, wenn nur noch 1 Tag übrig
      if (days < 2) {
        this.labelDays.innerHTML = "Tag";
      }

      // If the countdown is finished, write some text
      if (distance < 0) {
        clearInterval(interval);
        if (this.hiddenComponent) {
          this.hiddenComponent.classList.remove(CLASS_HIDDEN);
        }
        this.counterComponent.classList.add(CLASS_HIDDEN);
      }
    }, 1000);
  }

  setCountdownValue(selector, value) {
    this.querySelector(selector).innerHTML = this.addLeadingZero(value);
  }

  addLeadingZero(number) {
    return number > 9 ? number : "0" + number;
  }
}

if (!customElements.get("banner-fullsize-countdown")) {
  customElements.define("banner-fullsize-countdown", BannerFullsizeCountdown);
}
